import React, { PropsWithChildren, useEffect } from "react";

import { createClasses } from "@bloomberg/media-ui-core";
import styles from "./styles.module.css";

type ModalProps = {
  className?: string;
  open: boolean;
  onClose: () => void;
  closeOnOutsideClick?: boolean;
};

export default function Modal(props: PropsWithChildren<ModalProps>) {
  const {
    className,
    open,
    children,
    onClose,
    closeOnOutsideClick = true,
  } = props;

  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        // ESC key
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  if (!open) return null;

  const handleBackdropClick = (event: React.MouseEvent) => {
    if (
      (event.target as HTMLDivElement).id === "modal-backdrop" &&
      closeOnOutsideClick
    ) {
      onClose();
    }
  };

  return (
    <div
      id="modal-backdrop"
      role="presentation"
      onClick={handleBackdropClick}
      className={styles.modalBackdrop}
    >
      <div
        className={createClasses([styles.modal, className])}
        role="dialog"
        aria-modal="true"
      >
        {children}
      </div>
    </div>
  );
}
